export const obj = [
  {
    AccountName: "xdr_in test",
    ActionName: "",
    Address: null,
    City: null,
    ContactEmail: "vchitty@secureexsolutions.com",
    CreatedBy: "SESAdministrator",
    CreatedByDisplay: "SESAdministrator",
    DateCreated: "/Date(1547577992347)/",
    DateLastLogin: "/Date(1614278154007)/",
    DateModified: "/Date(1614779762183)/",
    DirectMail: " ",
    DomainName: "sestest.direct-address.com",
    EmailConfirmed: true,
    FirstName: "xdr_in",
    Id: 125,
    LastName: "test",
    ModifiedBy: "SESAdministrator",
    ModifiedByDisplay: "SESAdministrator",
    OrgId: 30,
    OrgName: "XDR-Org",
    Role: "Admin",
    State: null,
    Status: "Active",
    TFAEmail: "vchitty@abc.com",
    TFAOn: false,
    TFAPhone: null,
    TFAStatus: 1,
    Type: "Professional",
    UserName: "xdrtest|sestest.direct-address.com",
    UserNameDisplay: "xdrtest",
    VendorName: "Top-Org Admin",
    Zip: null,
  },
  {
    AccountName: "John Smith",
    ActionName: "",
    Address: null,
    City: null,
    ContactEmail: "jsmith@secureexsolutions.com",
    CreatedBy: "SESAdministrator",
    CreatedByDisplay: "SESAdministrator",
    DateCreated: "/Date(1547577992347)/",
    DateLastLogin: "/Date(1614278154007)/",
    DateModified: "/Date(1614779762183)/",
    DirectMail: " ",
    DomainName: "jsmith.direct-address.com",
    EmailConfirmed: true,
    FirstName: "John",
    Id: 176,
    LastName: "Smith",
    ModifiedBy: "SESAdministrator",
    ModifiedByDisplay: "SESAdministrator",
    OrgId: 30,
    OrgName: "XDR-Org",
    Role: "Member",
    State: null,
    Status: "Active",
    TFAEmail: "vchitty@abc.com",
    TFAOn: false,
    TFAPhone: null,
    TFAStatus: 1,
    Type: "Professional",
    UserName: "jsmith|sestest.direct-address.com",
    UserNameDisplay: "jsmith",
    VendorName: "Top-Org Admin",
    Zip: null,
  },
  {
    AccountName: "Jane Doe",
    ActionName: "",
    Address: null,
    City: null,
    ContactEmail: "vchitty@secureexsolutions.com",
    CreatedBy: "SESAdministrator",
    CreatedByDisplay: "SESAdministrator",
    DateCreated: "/Date(1547577992347)/",
    DateLastLogin: "/Date(1614278154007)/",
    DateModified: "/Date(1614779762183)/",
    DirectMail: " ",
    DomainName: "jdoe.direct-address.com",
    EmailConfirmed: true,
    FirstName: "Jane",
    Id: 175,
    LastName: "Doe",
    ModifiedBy: "SESAdministrator",
    ModifiedByDisplay: "SESAdministrator",
    OrgId: 30,
    OrgName: "XDR-Org",
    Role: "Admin",
    State: null,
    Status: "Active",
    TFAEmail: "vchitty@abc.com",
    TFAOn: false,
    TFAPhone: null,
    TFAStatus: 1,
    Type: "Professional",
    UserName: "xdrtest|sestest.direct-address.com",
    UserNameDisplay: "jdoe",
    VendorName: "Top-Org Admin",
    Zip: null,
  },
  {
    AccountName: "steve boka",
    ActionName: "",
    Address: null,
    City: null,
    ContactEmail: "sboka@secureexsolutions.com",
    CreatedBy: "SESAdministrator",
    CreatedByDisplay: "SESAdministrator",
    DateCreated: "/Date(1547577992347)/",
    DateLastLogin: "/Date(1614278154007)/",
    DateModified: "/Date(1614779762183)/",
    DirectMail: " ",
    DomainName: "sestest.direct-address.com",
    EmailConfirmed: true,
    FirstName: "Steve",
    Id: 171,
    LastName: "Boka",
    ModifiedBy: "SESAdministrator",
    ModifiedByDisplay: "SESAdministrator",
    OrgId: 30,
    OrgName: "XDR-Org",
    Role: "Member",
    State: null,
    Status: "Active",
    TFAEmail: "vchitty@abc.com",
    TFAOn: false,
    TFAPhone: null,
    TFAStatus: 1,
    Type: "Professional",
    UserName: "xdrtest|sestest.direct-address.com",
    UserNameDisplay: "sboka",
    VendorName: "Top-Org Admin",
    Zip: null,
  },
  {
    AccountName: "dseth",
    ActionName: "",
    Address: null,
    City: null,
    ContactEmail: "vchitty@secureexsolutions.com",
    CreatedBy: "SESAdministrator",
    CreatedByDisplay: "SESAdministrator",
    DateCreated: "/Date(1547577992347)/",
    DateLastLogin: "/Date(1614278154007)/",
    DateModified: "/Date(1614779762183)/",
    DirectMail: " ",
    DomainName: "dseth.direct-address.com",
    EmailConfirmed: true,
    FirstName: "Daniel",
    Id: 283,
    LastName: "Seth",
    ModifiedBy: "SESAdministrator",
    ModifiedByDisplay: "SESAdministrator",
    OrgId: 30,
    OrgName: "XDR-Org",
    Role: "Member",
    State: null,
    Status: "Active",
    TFAEmail: "vchitty@abc.com",
    TFAOn: false,
    TFAPhone: null,
    TFAStatus: 1,
    Type: "Professional",
    UserName: "dseth|sestest.direct-address.com",
    UserNameDisplay: "dseth",
    VendorName: "Top-Org Admin",
    Zip: null,
  },
  {
    AccountName: "Alket Hoxha",
    ActionName: "",
    Address: null,
    City: null,
    ContactEmail: "ahoxha@secureexsolutions.com",
    CreatedBy: "SESAdministrator",
    CreatedByDisplay: "SESAdministrator",
    DateCreated: "/Date(1547577992347)/",
    DateLastLogin: "/Date(1614278154007)/",
    DateModified: "/Date(1614779762183)/",
    DirectMail: " ",
    DomainName: "sestest.direct-address.com",
    EmailConfirmed: true,
    FirstName: "Alket",
    Id: 289,
    LastName: "Hoxha",
    ModifiedBy: "SESAdministrator",
    ModifiedByDisplay: "SESAdministrator",
    OrgId: 30,
    OrgName: "XDR-Org",
    Role: "Member",
    State: null,
    Status: "Active",
    TFAEmail: "vchitty@abc.com",
    TFAOn: false,
    TFAPhone: null,
    TFAStatus: 1,
    Type: "Professional",
    UserName: "ahoxha|sestest.direct-address.com",
    UserNameDisplay: "ahoxha",
    VendorName: "Top-Org Admin",
    Zip: null,
  },
];
export const customerFakeData = [
  {
    Name: "Humana",
    Value: "Humana",
    Id: 1,
  },
  {
    Name: "AllMeds",
    Value: "AllMeds",
    Id: 2,
  },
  {
    Name: "Centene",
    Value: "Centene",
    Id: 3,
  },
];
export const OrgFakeData = [
  {
    Name: "Humana",
    OrgId: 1,
    CustomerId: 1,
  },
  {
    Name: "AllMeds",
    OrgId: 2,
    CustomerId: 1,
  },
  {
    Name: "Centene",
    OrgId: 3,
    CustomerId: 2,
  },
  {
    Name: "Clinical Connect HIE ",
    OrgId: 4,
    CustomerId: 3,
  },
  {
    Name: "Centene 3",
    OrgId: 5,
    CustomerId: 3,
  },
  {
    Name: "Humana 3",
    OrgId: 6,
    CustomerId: 3,
  },
];
export const SearchModel = {
  VendorId: null,
  UserName: null,
  FirstName: null,
  LastName: null,
  OrganizationName: null,
  OrganizationId: null,
  NationalProviderID: null,
  ContactEmail: null,
  DirectEmail: null,
  City: null,
  State: null,
  Zip: null,
  SpecializationId: null,
  SpecializationCode: null,
  AdminsOnly: false,
  OrgUserSearch: false,
  DomainName: null,
};
export const stateCodeArray = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "VI",
  "WA",
  "WV",
  "WI",
  "WY",
  "PR",
];
